export class User {
  Id: string;
  Username: string;
  Password?: string;
  token?: any;

  constructor(values: Object = {}) {
    Object.assign(this, values);
  }
}

export class LoginModel {
  name: string = "";
  password: string = "";

  constructor() {
  }
}




// WEBPACK FOOTER //
// ./src/app/schemas/User.ts